<template>
    <div>
        <h1 style="font-size: 24px; color: black;">提现配置</h1>
        <el-card class="form-container" shadow="never">
            <el-form  label-width="150px" v-model="cashBaseFrom" >
                <el-row>
                <el-col :span="5">
                <el-form-item label="平台币汇率：" >
                    <el-input style="width: 150px; height: 40px" v-model="cashBaseFrom.exchangeRate" disabled ></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="（兑换 1元人民币 所需要的平台币数值）"  label-width="280px" >
                        <el-button style="position: relative; left: 500px;" type="primary" @click="release" >一键发布</el-button>
                    </el-form-item>
                </el-col>
                </el-row>
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="提现金额：" >
                            <el-button  circle icon="el-icon-plus"  type="primary" @click="addCash" ></el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="余额不足，引导到指定页面："   label-width="200px">
                            <el-select v-model="cashBaseFrom.redirect" filterable placeholder="请选择/输入">
                                <el-option
                                        v-for="item in redirect"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="list"
                      style="width: 100%"
                      border>
                <el-table-column label="提现金额"  align="center">
                    <template slot-scope="scope">
                        <el-input-number :min="0" :step="0.1" v-model="scope.row.money"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="提现次数"  align="center">
                    <template slot-scope="scope">
                        <el-input-number :min="0" v-model="scope.row.offerLimit"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="提现门槛"  align="center">
                        <el-table-column label="登录天数"  align="center">
                            <template slot-scope="scope">
                            <el-input-number :min="0" v-model="scope.row.loginTimes"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="视频个数"  align="center">
                            <template slot-scope="scope">
                            <el-input-number :min="0" v-model="scope.row.ads"></el-input-number>
                            </template>
                        </el-table-column>
                </el-table-column>
                <el-table-column label="排序" align="center">
                    <template slot-scope="scope">
                        <el-input-number :min="1" v-model="scope.row.sort"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button  circle icon="el-icon-minus" size="mini" type="danger"
                                   @click.native.prevent="reduceCash(scope.$index,list)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {
        rateList,
        cashOutConfigList,
        addCash,
        addRate
    } from "@/http/api";
    export default {
        inject: ['reload'],
        name: "CashOutConfig",
        data(){
            return{
                list:[],
                redirect:[{id:0,name:'扭蛋抽奖页面'},
                    {id:1,name:'碎片抽奖页面'},
                    {id:2,name:'福利页面'}],
                cashBaseFrom :{
                    id:0,
                    exchangeRate:10000,
                    redirect:1
                },
             }
        },
        methods:{
            addCash(){
                this.list.push({
                    id: 0,
                    money: 0,
                    offerLimit: 1,
                    ads: 0,
                    loginTimes:0,
                    sort: 1,
                    isShow:true,
                })
            },
            reduceCash(index, rows) {
                rows.splice(index, 1);
            },
            release(){
                addRate(this.cashBaseFrom).then(resp => {
                   if (resp.data.status===0){
                       addCash(this.list).then(resp => {
                           if(resp.data.status===0){
                               this.$message({
                                   message: '发布成功',
                                   type: 'success',
                                   duration: 1000
                               });
                               this.reload();
                           }
                       });
                   }
                })
            }
        },
        created() {
            cashOutConfigList().then(resp => {
                this.list = resp.data.info;
            });
            rateList().then(resp => {
                if(resp.data.info.length>0){
                    this.cashBaseFrom = resp.data.info[0];
                }
            });
        }
    }
</script>

<style scoped>

</style>